export default __webpack_public_path__ + "static/media/527.0d397d0d.png";